import { AutoResolutionType, FeedbackType } from './Feedback';

export enum FeedbackGroupState {
  AWAITING_FEEDBACK = 'AWAITING_FEEDBACK',
  FEEDBACK_SUBMITTED = 'FEEDBACK_SUBMITTED',
}

type FeedbackOption = {
  optionId: string;
  updatedDocumentReferenceUrl: string;
};

export type FeedbackGroup = {
  groupId: string;
  orderNumber: string;
  originalDocumentReferenceUrl: string;
  type: FeedbackType;
  lineItemIds: string[];
  agentFeedback: string[];
  proposedOptions: FeedbackOption[];
  responseDeadlineDate: string;
  responseDeadlineBusinessDays: number;
  tenantId: string;
  shopperId: string;
  autoResolutionType: AutoResolutionType;
  state: FeedbackGroupState;
};

type FeedbackGroups = {
  feedbackGroups: FeedbackGroup[];
};

export default FeedbackGroups;
